import React from 'react';
import PropTypes from 'prop-types';

import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import {
  Type,
  CenteredContainer,
  Title,
  Text,
  Stack,
  Columns,
  Column,
} from '@nerdwallet/currency';
import AuthFlowButton from '@nerdwallet/react-auth-flow-button';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import appConfig from '@nerdwallet/app-config';
import Image from '@nerdwallet/react-image';
import { colors } from '@nerdwallet/base-styles/variables';

const AccountModule = ({
  eyebrow,
  title,
  description,
  ctaText,
  imageSrcDesktop,
  imageSrcMobile,
  trkCopy,
}) => {
  const imageDesktop = (
    <Image
      className="acct__img-desktop"
      src={imageSrcDesktop}
      alt="A simplified NerdWallet account dashboard page showing credit score and net worth information with close-ups on spending"
      backgroundColor={colors.transparent}
      lazy
    />
  );

  const imageTablet = (
    <Image
      className="image"
      src={imageSrcDesktop}
      alt="A simplified NerdWallet account dashboard page showing credit score and net worth information with close-ups on spending"
      backgroundColor={colors.transparent}
      lazy
    />
  );

  const imageMobile = (
    <Image
      className="image"
      src={imageSrcMobile}
      alt="The NerdWallet mobile app, displaying a user’s net worth and cash flow with a close-up of account allocation"
      backgroundColor={colors.transparent}
      lazy
    />
  );

  return (
    <BedrockImpression entityName="member_registration_container">
      <ElementImpression
        elementDomType="div"
        elementName="Membership"
        id="membership-container"
      >
        <CenteredContainer className="acct">
          <Column width={5}>
            <Stack spacing="3-half">
              <Type light uppercase size={1} bold className="acct__eyebrow">
                {eyebrow}
              </Type>
              <Title size="small" component="h2">
                {title}
              </Title>
              <div className="acct__img-mobile">{imageMobile}</div>
              <div className="acct__img-tablet">{imageTablet}</div>
              <Text>{description}</Text>
              <Columns>
                <Column width={{ mobile: 12, desktop: 7 }}>
                  <AuthFlowButton
                    flowPreset="onboardingGeneric"
                    flowProps={{
                      trk: {
                        trk_copy: trkCopy,
                      },
                    }}
                    className="acct__join-btn"
                    entityName="acct_module_registration"
                  >
                    {ctaText}
                  </AuthFlowButton>
                </Column>
              </Columns>
            </Stack>
          </Column>
          <Column width={7}>
            <div className="acct__img-desktop-wrapper">{imageDesktop}</div>
          </Column>
        </CenteredContainer>
      </ElementImpression>
    </BedrockImpression>
  );
};

AccountModule.propTypes = {
  ctaText: PropTypes.string,
  description: PropTypes.string,
  eyebrow: PropTypes.string,
  title: PropTypes.string,
  trkCopy: PropTypes.string,
  imageSrcDesktop: PropTypes.string,
  imageSrcMobile: PropTypes.string,
};

AccountModule.defaultProps = {
  ctaText: 'Get started',
  imageSrcDesktop: `${appConfig.ASSETS_URL}/images/account_module_desktop_ab.svg`,
  imageSrcMobile: `${appConfig.ASSETS_URL}/images/account_module_mobile_ab.svg`,
};

export default AccountModule;
